import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import React, { Component } from 'react';
import { defineMessages, FormattedMessage, FormattedNumber, injectIntl } from "react-intl";
import ActionButton from "../../../../common/button/actionbutton.component.jsx";
import Checkbox from "../../../../common/checkbox/checkbox.component.jsx";
import CountrySelect from "../../../../common/contact/countryselector.component.jsx";
import StateSelect from "../../../../common/contact/stateselector.component.jsx";
import EventBus from "../../../../common/EventBus.js";
import GlobalHelper from "../../../../common/GlobalHelper.jsx";
import Icon from '../../../../common/icon/icon.component.jsx';
import EmailInput from '../../../../common/inputs/EmailInputComponent.tsx';
import PhoneNumberInput from '../../../../common/inputs/PhoneNumberInputComponent.tsx';
import PostalCodeInput from '../../../../common/inputs/PostalCodeInputComponent.tsx';
import AddressComponentSSR from "../../../../customer/components/AddressComponentSSR";
import { getPriceListName } from "../../../../name-helpers/priceListNameHelper";
import PriceListStatusBadge from "../../../../price-list/status.component.jsx";
import { TypeCustomFieldRequiredError, TypeLineItemProductCustomAttributeRequiredError } from '../../../../state/helpers/ErrorTypes';
import { PAYMENT_SOURCE } from "../../../../state/helpers/Payment";
import { INTEGRATION_KEY } from "../../../../state/integration/Constants";
import SectionWrapper from "../../sectionwrapper.component.jsx";
import PaymentTypeTabs from './paymentTypeTabs.component.jsx';


const messages = defineMessages({
    first_name_placeholder: {
        id: 'checkout.first_name_placeholder',
        defaultMessage: 'First name',
    },
    last_name_placeholder: {
        id: 'checkout.last_name_placeholder',
        defaultMessage: 'Last name',
    },
    email_placeholder: {
        id: 'checkout.email_placeholder',
        defaultMessage: 'Email',
    },
    address_placeholder: {
        id: 'checkout.address_placeholder',
        defaultMessage: 'Address',
    },
    city_placeholder: {
        id: 'checkout.city_placeholder',
        defaultMessage: 'City',
    },
    country_placeholder: {
        id: 'checkout.country_placeholder',
        defaultMessage: 'Country',
    },
    state_placeholder: {
        id: 'checkout.state_placeholder',
        defaultMessage: 'State',
    },
    province_placeholder: {
        id: 'checkout.province_placeholder',
        defaultMessage: 'Province',
    },
    postal_code_placeholder: {
        id: 'checkout.postal_code_placeholder',
        defaultMessage: 'Postal code',
    },
    zip_placeholder: {
        id: 'checkout.zip_placeholder',
        defaultMessage: 'Zip',
    },
    phone_number_placeholder: {
        id: 'checkout.phone_number_placeholder',
        defaultMessage: 'Phone number',
    },
    payment_note: {
        id: 'payment.payment_note',
        defaultMessage: 'Online payment',
    },
})

const cookieKey = 'qm_ck_data'

class CheckoutContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            className: this.props.className || '',
            section: this.props.section || null,
            isDummy: this.props.isDummy === true,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            isPdf: this.props.isPdf || false,
            autoOpen: this.props.autoOpen || false,
            included: this.props.included || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            id: this.props.id || '',
            checkValidForm: false,
            sameBillingAddress: true,
            loading: false,
            creditCardError: '',
            publicKey: '',
            firstName: '',
            lastName: '',
            address: '',
            city: '',
            state: '',
            country: '',
            postalCode: '',
            billingEmail: '',
            billingFirstName: '',
            billingLastName: '',
            billingAddress: '',
            billingCity: '',
            billingState: '',
            billingCountry: '',
            billingPostalCode: '',
            email: '',
            phoneNumber: '',
            isValidPhoneNumber: true,
            contactId: '',
            shipToContactId: '',
            billingPhoneNumber: '',
            isValidBillingPhoneNumber: true,
            redirect: '',
            showPaymentStep: false,
            options: [],
            itemQuantities: [],
            selectedChoices: [],
            customFieldValues: null,
            proceedingToPayment: false,
            paymentMethods: this.props.section.attributes.content.paymentMethods || ['credit-card', 'on-account', 'bank-transfer'],
            acceptedCardBrands: this.props.section?.attributes?.content?.acceptedCardBrands || [],
            validationError: '',
            formError: '',
            itemCustomAttributeValues: [],
            itemCustomAttributeError: false,
            customFieldRequiredError: false,
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleBillingPhoneChange = this.handleBillingPhoneChange.bind(this)
        this.handlePhoneChange = this.handlePhoneChange.bind(this)
        this.continueToPayment = this.continueToPayment.bind(this)
        this.backToContact = this.backToContact.bind(this)
        this.handleProposalRefresh = this.handleProposalRefresh.bind(this)
        this.handleOptionsChange = this.handleOptionsChange.bind(this)
        this.handleSubmitNewCard = this.handleSubmitNewCard.bind(this)
        this.handlePaymentIntentCompleted = this.handlePaymentIntentCompleted.bind(this)
        this.saveInCookies = this.saveInCookies.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.getDueAmount = this.getDueAmount.bind(this)
        this.getPaymentAmount = this.getPaymentAmount.bind(this)
        this.handleCustomFieldChange = this.handleCustomFieldChange.bind(this)
        this.handlePaymentIntentCompleted = this.handlePaymentIntentCompleted.bind(this)
        this.validateCustomer = this.validateCustomer.bind(this)
        this.handleCreatePendingExternalCheckoutPayment = this.handleCreatePendingExternalCheckoutPayment.bind(this)
        this.getFormattedAmount = this.getFormattedAmount.bind(this)
        this.buildMetaData = this.buildMetaData.bind(this)
        this.hasShopifyCheckout = this.hasShopifyCheckout.bind(this)
        this.getPaymentTransactionBasePayload = this.getPaymentTransactionBasePayload.bind(this)

        //Subscription to event bus
        EventBus.listen(EventBus.TopicProposalRefresh, 'checkout-section', this.handleProposalRefresh)
        EventBus.listen(EventBus.TopicPricingTableOptionsSelectedChanged, 'checkout-section', this.handleOptionsChange)
        EventBus.listen(EventBus.TopicCustomFormFieldChanged, 'checkout-section', this.handleCustomFieldChange)
        EventBus.listen(EventBus.TopicCreateExternalCheckoutPaymentTransaction, 'checkout-section', this.handleCreatePendingExternalCheckoutPayment)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            section: nextProps.section || null,
            variables: nextProps.variables || null,
            isDummy: nextProps.isDummy === true,
            id: nextProps.id || '',
            isPdf: nextProps.isPdf || false,
        })
    }

    isLoggedIn() {
        const userId = AppContext.getUserLoggedIn() && AppContext.getUserLoggedIn().id ? AppContext.getUserLoggedIn().id : ''
        return userId != ''
    }

    componentDidMount() {
        let stateCode = GlobalHelper.getStateCodeFromAddress(this.state.variables.company.address, this.state.variables.global.language)
        let countryCode = GlobalHelper.getCountryCodeFromAddress(this.state.variables.company.address, this.state.variables.global.language, 'US')

        let data = {
            state: stateCode,
            country: countryCode,
            billingState: stateCode,
            billingCountry: countryCode,
        }
        let json = AppContext.getCookie(cookieKey)
        let saved = {}
        try {
            if (json) {
                json = atob(json)
            }
            saved = json ? JSON.parse(json) : {}
        } catch (e) { }

        if (!this.isLoggedIn()) {
            for (let field in saved) {
                if (saved[field] !== '') {
                    data[field] = saved[field]
                }
            }
        }

        data.isValidBillingPhoneNumber = GlobalHelper.isValidPhoneNumberInput(data.billingPhoneNumber)
        data.isValidPhoneNumber = GlobalHelper.isValidPhoneNumberInput(data.phoneNumber)
        this.setState(data)
    }

    handleOptionsChange(event) {
        this.setState({
            itemCustomAttributeValues: event.getData().itemCustomAttributeValues,
            options: event.getData().options,
            itemQuantities: event.getData().itemQuantities,
            selectedChoices: event.getData().selectedChoices,
        })
    }

    handleCustomFieldChange(event) {
        let values = this.state.customFieldValues || {}
        values[event.getData().customFieldId] = event.getData().customFieldValue
        this.setState({
            customFieldValues: values,
        })
    }

    saveInCookies() {
        const fields = [
            'firstName',
            'lastName',
            'address',
            'city',
            'state',
            'country',
            'postalCode',
            'billingEmail',
            'billingFirstName',
            'billingLastName',
            'billingAddress',
            'billingCity',
            'billingState',
            'billingCountry',
            'billingPostalCode',
            'email',
            'phoneNumber',
            'contactId',
            'shipToContactId',
            'billingPhoneNumber',
            'showPaymentStep',
            'sameBillingAddress',
            'validationError',
        ]
        let data = {}
        for (let i in fields) {
            const field = fields[i]
            data[field] = this.state[field]
        }
        AppContext.setCookie(cookieKey, btoa(JSON.stringify(data)))
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            proceedingToPayment: false,
            formError: '',
            [target.name]: target.value
        }, this.saveInCookies)
    }

    handleBillingPhoneChange(phoneNumber, isValidPhoneNumber) {
        this.setState({
            isValidBillingPhoneNumber: isValidPhoneNumber,
            proceedingToPayment: false,
            formError: '',
            billingPhoneNumber: phoneNumber,
        })
    }

    handlePhoneChange(phoneNumber, isValidPhoneNumber) {
        this.setState({
            isValidPhoneNumber: isValidPhoneNumber,
            formError: '',
            proceedingToPayment: false,
            phoneNumber: phoneNumber,
        })
    }

    async continueToPayment(e) {
        e.preventDefault()
        this.setState({ checkValidForm: true })

        const isFormValid = this.validateCustomerForm() &&
            this.state.isValidPhoneNumber &&
            ((!this.state.sameBillingAddress && this.state.isValidBillingPhoneNumber) || this.state.sameBillingAddress)

        if (!isFormValid) {
            this.setState({
                validationError: 'form-invalid',
                proceedingToPayment: false,
            })
            return
        }

        const isValidCustomer = await this.validateCustomer()
        if (!isValidCustomer) {
            return
        }

        const payloadPhoneNumbers = []
        if (this.state.phoneNumber) {
            payloadPhoneNumbers.push({
                type: "primary",
                phoneNumber: this.state.phoneNumber,
                extension: ''
            })
        }

        if (this.state.email.trim() == this.state.billingEmail.trim() || this.state.sameBillingAddress) {
            let billingAddress = {
                street: this.state.billingAddress,
                city: this.state.billingCity,
                postalCode: this.state.billingPostalCode,
                stateCode: this.state.billingState,
                countryCode: this.state.billingCountry,
                addressType: "billing",
                isDefault: true,
            }

            let shippingAddress = {
                street: this.state.address,
                city: this.state.city,
                postalCode: this.state.postalCode,
                stateCode: this.state.state,
                countryCode: this.state.country,
                addressType: "shipping",
                isDefault: true,
            }

            if (this.state.sameBillingAddress) {
                billingAddress = { ...shippingAddress }
                billingAddress.addressType = "billing"
            }

            const resBoth = await AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/contacts', {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email.trim(),
                phoneNumbers: payloadPhoneNumbers,
                language: this.state.variables.global.language,
                shippingAddress: shippingAddress,
                address: billingAddress,
            })

            let data = {
                showPaymentStep: true,
                contactId: resBoth.id,
            }

            if (resBoth.error) {
                data.formError = resBoth.error.message
                data.showPaymentStep = false
            }

            this.setState(data, this.saveInCookies)
        } else {
            let shippingAddress = {
                street: this.state.address,
                city: this.state.city,
                postalCode: this.state.postalCode,
                stateCode: this.state.state,
                countryCode: this.state.country,
                addressType: "shipping",
                isDefault: true,
            }

            const resShipping = await AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/contacts', {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email.trim(),
                phoneNumbers: payloadPhoneNumbers,
                language: this.state.variables.global.language,
                address: shippingAddress,
            })

            let data = {
                proceedingToPayment: false,
            }

            if (this.state.sameBillingAddress && !resShipping.error) {
                data.contactId = resShipping.id
            }

            if (resShipping.error) {
                data.formError = resShipping.error.message
            }

            this.setState(data, this.saveInCookies)
            const payloadPhoneNumbersBilling = []
            if (this.state.phoneNumber) {
                payloadPhoneNumbersBilling.push({
                    type: "primary",
                    phoneNumber: this.state.billingPhoneNumber,
                    extension: ''
                })
            }

            const resBilling = await AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/contacts', {
                firstName: this.state.billingFirstName,
                lastName: this.state.billingLastName,
                email: this.state.billingEmail.trim(),
                phoneNumbers: payloadPhoneNumbersBilling,
                language: this.state.variables.global.language,
                shippingAddress: shippingAddress,
                address: {
                    street: this.state.billingAddress,
                    city: this.state.billingCity,
                    postalCode: this.state.billingPostalCode,
                    stateCode: this.state.billingState,
                    countryCode: this.state.billingCountry,
                    addressType: "billing",
                    isDefault: true,
                },
            })

            if (resBilling.error) {
                this.setState({
                    formError: resBilling.error.message,
                    proceedingToPayment: false,
                })
            } else {
                this.setState({
                    showPaymentStep: true,
                    contactId: resBilling.id,
                }, this.saveInCookies)
            }
        }

        this.setState({ checkValidForm: false })
    }

    backToContact(e) {
        e.preventDefault()
        this.setState({
            showPaymentStep: false,
            contactId: '',
        }, this.saveInCookies)
    }

    async validateCustomer() {
        const proposalHash = this.props.variables.hash
        const payload = {
            contactEmail: this.state.email,
        }
        const res = await AppContext.getApiClient().post('/proposals/' + proposalHash + '/validate-customer', payload)
        let validationError = ""
        let proceedToPayment = true
        if (res.error) {
            validationError = res.error.message
            proceedToPayment = res.error.message == "error-golf-contact"
        }
        this.setState({
            validationError: validationError,
            proceedingToPayment: proceedToPayment,
        })

        return proceedToPayment
    }

    validateCustomerForm() {
        let form = document.getElementById("customer-form")
        const checkResult = form.checkValidity()
        form.classList.add('was-validated')
        return checkResult
    }

    getPaymentAmount() {
        if (!this.state.variables.quote.needDepositPayment && this.state.variables.quote.objectType === 'quote') {
            return 0
        }
        return this.state.variables.quote.needDepositPayment ?
            this.state.variables.quote.depositAmount :
            this.state.variables.quote.totalAmount

    }

    handleProposalRefresh(event) {
        this.setState({
            variables: event.getData().variables,
        })
    }

    handleCreatePendingExternalCheckoutPayment(event) {
        const data = {
            note: this.props.intl.formatMessage(messages.payment_note),
            paymentType: "credit-card",
            currency: this.state.variables.quote.currency,
            contactId: this.state.contactId,
            source: 'online',
            fingerprintId: GlobalHelper.getFingerprintId(),
            newOrder: {
                contactId: this.state.contactId,
                amount: this.getPaymentAmount().toString(),
                itemQuantities: this.state.itemQuantities,
                chosenOptions: this.state.options,
                selectedChoices: this.state.selectedChoices,
                itemCustomAttributeValues: this.state.itemCustomAttributeValues,
            },
            integrationKey: this.state.variables.global.externalCheckoutIntegrationKey,
            externalCheckout: {
                source: 'online',
            },
            locationId: this.state.variables.quote.locationId
        }
        if (this.state.customFieldValues) {
            data.newOrder.project = {
                customFieldValues: this.state.customFieldValues
            }
        }
        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/payment-transactions', data).then(res => {
            if (res.error || res == null) {
                this.setState({
                    loading: false,
                    creditCardError: <div className={"col-12"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                })
            } else {
                this.setState({
                    creditCardError: '',
                })

                const lastPayment = res.attributes.variables.lastPayment
                if (lastPayment && lastPayment.attributes.externalLink &&
                    lastPayment.attributes.externalLink.attributes.externalUrl) {

                    if (!event.getData().openNewTab) {
                        window.location = lastPayment.attributes.externalLink.attributes.externalUrl
                        return
                    }

                    window.open(lastPayment.attributes.externalLink.attributes.externalUrl)
                    EventBus.dispatch(EventBus.TopicPaymentTransactionCreated, {
                        payment: lastPayment,
                    })

                    setInterval(() => {
                        AppContext.getApiClient().get('/proposals/' + res.attributes.hash).then(res => {
                            const lastPayment = res.attributes.variables.lastPayment
                            if (!res.error && lastPayment.attributes.status === 'captured') {
                                AppContext.setCookie('qm_pt_data', '')
                                window.location = '/p/proposals/' + res.attributes.hash
                            }
                        })
                    }, 1500)
                }
            }
        })
    }

    getPaymentTransactionBasePayload() {
        const basePayload = {
            note: this.props.intl.formatMessage(messages.payment_note),
            paymentType: "credit-card", //to override by child payment components if paymentType is not "credit-card"
            currency: this.state.variables.quote.currency,
            contactId: this.state.contactId,
            source: 'online',
            fingerprintId: GlobalHelper.getFingerprintId(),
            newOrder: {
                contactId: this.state.contactId,
                amount: this.getPaymentAmount().toString(),
                itemQuantities: this.state.itemQuantities,
                chosenOptions: this.state.options,
                selectedChoices: this.state.selectedChoices,
                itemCustomAttributeValues: this.state.itemCustomAttributeValues,
            },
            locationId: this.state.variables.quote.locationId
        }
        if (this.state.customFieldValues) {
            basePayload.newOrder.project = {
                customFieldValues: this.state.customFieldValues
            }
        }
        return basePayload
    }

    handleSubmitNewCard(setupIntent, token, saveCard, error, next) {
        if (error) {
            this.setState({
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{error.message}</small>
                </div>
            })
            next()
            return
        }

        const data = this.getPaymentTransactionBasePayload()

        data.creditCard = {
            saveCard
        }

        if (this.state.customFieldValues) {
            data.newOrder.project = {
                customFieldValues: this.state.customFieldValues
            }
        }
        if (token && token.billingDetails) {
            data.billingDetails = token.billingDetails
        }
        if (token && token.token) {
            data.creditCard = {
                singleUseToken: token.token,
                saveCard: token.saveCard,
                paymentFlow: 'token',
                verificationToken: token.verificationToken
            }
        }

        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/payment-transactions', data).then(res => {
            this.setState({
                creditCardError: '',
            })

            if (res.error || res == null) {
                this.setState({
                    loading: false,
                    creditCardError: <div className={"col-12"}>
                        <small className={"text-danger"}>{res.error.message}</small>
                    </div>
                })
            } else {
                this.setState({
                    newProposalHash: res.attributes.hash,
                    newProposalVariables: res.attributes.variables,
                })
                const lastPayment = res.attributes.variables.lastPayment
                if (lastPayment.attributes.integratedPayment.attributes.status !== 'pending') {
                    AppContext.setCookie('qm_pt_data', '')
                    window.location = '/p/proposals/' + res.attributes.hash
                } else {
                    EventBus.dispatch(EventBus.TopicPaymentTransactionCreated, {
                        payment: lastPayment,
                    })
                }
            }
            next(res.error)
        })
    }

    handlePaymentIntentCompleted(paymentIntent) {
        if (!paymentIntent.error && paymentIntent.paymentIntent.status === 'succeeded') {
            this.setState({
                loading: true,
            })
            AppContext.getApiClient().post(`/proposals/${this.state.newProposalVariables.hash}/payments/${this.state.newProposalVariables.lastPayment.id}/confirm`, {}).then(res => {
                AppContext.setCookie('qm_pt_data', '')
                window.location = '/p/proposals/' + this.state.newProposalHash
            })
        } else {
            this.setState({
                loading: false,
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{paymentIntent.error.message}</small>
                </div>
            })
        }
    }

    isRainforestBankTransferEnabled() {
        return this.state.variables.global.paymentIntegrationKey === INTEGRATION_KEY.RAINFOREST &&
            this.state.paymentMethods.includes("bank-transfer") &&
            this.state.variables.global.hasIntegratedPayment &&
            this.state.variables.global.hasIntegratedPaymentBankAccount
    }

    getDueAmount() {
        return <div className={`mb-0 d-flex align-items-start flex-column ${this.isRainforestBankTransferEnabled() ? "col-lg-5" : "col-lg-6"}`}>
            <div className={'my-auto w-100'}>
                <h1 className={'text-center m-0'} style={{
                    fontWeight: 600,
                }}>
                    <FormattedNumber
                        value={this.getPaymentAmount()}
                        currency={this.state.variables.quote.currency}
                        style={'currency'}
                    />
                </h1>
                <p className={'text-center mb-1'}>
                    <FormattedMessage
                        id="payment.amount_due_label"
                        defaultMessage="Amount Due"
                    /> ({this.state.variables.quote.currency})
                </p>
            </div>
        </div>
    }

    handleSubmit(paymentOnAccount) {
        const data = {
            itemCustomAttributeValues: this.state.itemCustomAttributeValues,
            contactId: this.state.contactId,
            itemQuantities: this.state.itemQuantities,
            chosenOptions: this.state.options,
            selectedChoices: this.state.selectedChoices,
            paymentOnAccount: paymentOnAccount,
        }
        if (this.state.customFieldValues) {
            data.project = {
                customFieldValues: this.state.customFieldValues
            }
        }
        AppContext.getApiClient().post('/proposals/' + this.state.variables.hash + '/orders', data).then(res => {
            if (!res.error) {
                AppContext.setCookie('qm_pt_data', '')
                window.location = '/p/proposals/' + res.attributes.hash
            } else if (res.error.type === TypeLineItemProductCustomAttributeRequiredError) {
                this.setState({
                    itemCustomAttributeError: true
                })
            }
            else if (res.error.type === TypeCustomFieldRequiredError) {
                this.setState({
                    customFieldRequiredError: true,
                })
            }

        })
    }

    getFormattedAmount() {
        return parseFloat(this.getPaymentAmount()).toFixed(2).toString()
    }

    hasShopifyCheckout() {
        const ShopifyAppIntegrationKeys = [INTEGRATION_KEY.SHOPIFY, INTEGRATION_KEY.SHOPIFY_EXPERT_APP]
        return (this.state.section.attributes.content.hidePaymentSection &&
            this.state.variables.global.fullPaymentAndCheckoutOnly &&
            ShopifyAppIntegrationKeys.includes(this.state.variables.global.externalCheckoutIntegrationKey))
    }

    buildMetaData() {
        const variables = this.state.variables
        const orderFormPayload = this.getPaymentTransactionBasePayload()
        const integration = GlobalHelper.getPaymentIntegrationPerLocation(variables.quote.locationId)
        let integrationConfigurationId = integration ? integration.id : ""
        if (!integrationConfigurationId && variables.global.paymentIntegrationConfigurationId) {
            integrationConfigurationId = variables.global.paymentIntegrationConfigurationId
        }

        const metadata = {
            documentType: variables.document.type,
            identifier: variables.document.reference,
            documentId: variables.quote.id,
            contactId: this.state.contactId,
            accountId: variables.quote.accountId,
            locationId: variables.quote.locationId,
            fingerprintId: GlobalHelper.getFingerprintId(),
            amount: this.getFormattedAmount(),
            source: PAYMENT_SOURCE.ONLINE,
            currency: variables.global.baseCurrency,
            documentCurrency: variables.quote.currency,
            integrationConfigurationId: integrationConfigurationId,
            orderFormPayload: orderFormPayload,
        }
        return metadata
    }

    render() {
        if (!this.state.section || this.state.isPdf) {
            return <div />
        }

        if (this.state.variables && this.state.variables.paymentSectionDisabled) {
            return <div />
        }

        const errorMessage = this.state.validationError == 'customer-type-invalid' ?
            <div className="alert alert-danger" role="alert">
                <FormattedMessage
                    id="price_list.checkout.customer_type_error"
                    defaultMessage="You are not authorized to make an order on this {priceList}"
                    values={{
                        priceList: getPriceListName(this.props.intl)
                    }}
                />
            </div> : ""
        let shipToAddress = {
            street: this.state.address,
            city: this.state.city,
            postalCode: this.state.postalCode,
            stateCode: this.state.state,
            countryCode: this.state.country,
        }
        let shipToEmail = this.state.email
        let shipToPhoneNumber = this.state.phoneNumber
        let shipToName = this.state.firstName + ' ' + this.state.lastName

        let billingAddress = shipToAddress
        let billingEmail = this.state.email
        let billingName = shipToName
        let billingPhoneNumber = shipToPhoneNumber
        if (!this.state.sameBillingAddress) {
            billingAddress = {
                street: this.state.billingAddress,
                city: this.state.billingCity,
                postalCode: this.state.billingPostalCode,
                stateCode: this.state.billingState,
                countryCode: this.state.billingCountry,
            }
            billingEmail = this.state.billingEmail
            billingName = this.state.billingFirstName + ' ' + this.state.billingLastName
            billingPhoneNumber = this.state.billingPhoneNumber
        }

        const showPaymentStep = this.state.showPaymentStep && this.state.contactId

        if (this.state.variables.quote.status === 'inactive' || this.state.variables.quote.isDisabled) {
            return <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                included={this.state.included}
            >
                <div className={'w-100 text-center h2'}>
                    {
                        this.state.variables.quote.isDisabled ?
                            <PriceListStatusBadge status={"disabled"} /> :
                            <PriceListStatusBadge
                                isDisabled={this.state.variables.quote.isDisabled}
                                status={this.state.variables.quote.status}
                            />
                    }
                </div>
            </SectionWrapper>
        }

        const colContactInfoSize = this.state.section.attributes.content.hideShipping ? 'col-lg-6' : 'col-lg-3'
        const hidePayment = this.state.section.attributes.content.hidePaymentSection ||
            this.getPaymentAmount() == 0 ||
            (this.getPaymentAmount() > 0 && !this.state.variables.isIntegrationConfigurationEnabled)
        return (
            <SectionWrapper
                id={this.state.id}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                included={this.state.included}
            >
                {this.state.redirect}
                {!showPaymentStep ? <div className={'col-12 border-bottom py-2 mb-2'}>
                    {errorMessage}
                    <form className="needs-validation" id="customer-form" noValidate>
                        <div className={'row mb-2'}>
                            <div className={'col-12 d-flex align-items-center'}>
                                <div className={'h3 mb-0 mr-2 d-flex align-items-center'}>
                                    <span className="badge badge-pill badge-primary"
                                        style={{
                                            outlineColor: this.state.variables.global.primaryColor,
                                            backgroundColor: this.state.variables.global.primaryColor,
                                            borderColor: this.state.variables.global.primaryColor,
                                        }}
                                    >1</span>
                                </div>
                                <div className={'flex-fill'}>
                                    <h4 className={'mb-0'}>
                                        <FormattedMessage
                                            id="proposal.checkout.contact_information"
                                            defaultMessage="Contact information"
                                        />
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div className={'row px-3 mb-2'}>
                            <div className={'col-12'}>
                                <label htmlFor="email" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.email_label"
                                            defaultMessage="Email"
                                        />
                                    </small>
                                </label>
                                <EmailInput
                                    type="email"
                                    className="form-control "
                                    required={true}
                                    id="email"
                                    email={this.state.email}
                                    name="email"
                                    placeholder={this.props.intl.formatMessage(messages["email_placeholder"])}
                                    handleFormChange={this.handleFormChange}
                                />

                            </div>
                        </div>
                        <div className={'row px-3 mb-2'}>
                            <div className={'col-12 col-lg-6'}>
                                <label htmlFor="firstName" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.first_name_label"
                                            defaultMessage="First Name"
                                        />
                                    </small>
                                </label>
                                <input
                                    required
                                    type="text"
                                    className="form-control "
                                    id="firstName"
                                    name="firstName"
                                    value={this.state.firstName}
                                    placeholder={this.props.intl.formatMessage(messages["first_name_placeholder"])}
                                    onChange={this.handleFormChange}
                                />
                            </div>
                            <div className={'col-12 col-lg-6'}>
                                <label htmlFor="lastName" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.last_name_label"
                                            defaultMessage="Last Name"
                                        />
                                    </small>
                                </label>
                                <input
                                    required
                                    type="text"
                                    className="form-control "
                                    id="lastName"
                                    name="lastName"
                                    value={this.state.lastName}
                                    placeholder={this.props.intl.formatMessage(messages["last_name_placeholder"])}
                                    onChange={this.handleFormChange}
                                />
                            </div>
                        </div>
                        <div className={'row px-3 mb-2'}>
                            <div className={'col-12 col-lg-8'}>
                                <label htmlFor="address" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.address_label"
                                            defaultMessage="Address"
                                        />
                                    </small>
                                </label>
                                <input
                                    type="text"
                                    className="form-control "
                                    id="address"
                                    name="address"
                                    value={this.state.address}
                                    placeholder={this.props.intl.formatMessage(messages["address_placeholder"])}
                                    onChange={this.handleFormChange}
                                />
                            </div>
                            <div className={'col-12 col-lg-4'}>
                                <label htmlFor="city" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.city_label"
                                            defaultMessage="City"
                                        />
                                    </small>
                                </label>
                                <input
                                    type="text"
                                    className="form-control "
                                    id="city"
                                    name="city"
                                    value={this.state.city}
                                    placeholder={this.props.intl.formatMessage(messages["city_placeholder"])}
                                    onChange={this.handleFormChange}
                                />
                            </div>
                        </div>
                        <div className={'row px-3 mb-2'}>
                            <div className={'col-12 col-lg-4'}>
                                <label htmlFor="country" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.country_label"
                                            defaultMessage="Country"
                                        />
                                    </small>
                                </label>
                                <CountrySelect
                                    name="country"
                                    countryCode={this.state.country}
                                    onChange={(_, code) => {
                                        this.setState({ country: code }, this.saveInCookies)
                                    }}
                                />
                            </div>
                            <div className={'col-12 col-lg-4'}>
                                <label htmlFor="state" className={'mb-0 text-secondary'}>
                                    <small>
                                        {this.state.country === 'CA' ? <FormattedMessage
                                            id="proposal.checkout.province_label"
                                            defaultMessage="Province"
                                        /> : <FormattedMessage
                                            id="proposal.checkout.state_label"
                                            defaultMessage="State"
                                        />}
                                    </small>
                                </label>
                                <StateSelect
                                    name="state"
                                    value={this.state.state}
                                    countryCode={this.state.country}
                                    placeholder={this.props.intl.formatMessage(this.state.country === 'CA' ? messages["province_placeholder"] : messages["zip_placeholder"])}
                                    onChange={(_, code) => {
                                        this.setState({ state: code }, this.saveInCookies)
                                    }}
                                />
                            </div>
                            <div className={'col-12 col-lg-4'}>
                                <label htmlFor="postalCode" className={'mb-0 text-secondary'}>
                                    <small>
                                        {this.state.country === 'CA' ? <FormattedMessage
                                            id="proposal.checkout.postal_code_label"
                                            defaultMessage="Postal code"
                                        /> : <FormattedMessage
                                            id="proposal.checkout.zip_label"
                                            defaultMessage="Zip"
                                        />}
                                    </small>
                                </label>
                                <PostalCodeInput
                                    type="text"
                                    className="form-control "
                                    id="postalCode"
                                    name="postalCode"
                                    postalCode={this.state.postalCode}
                                    countryCode={this.state.country}
                                    placeholder={this.props.intl.formatMessage(this.state.country === 'CA' ? messages["postal_code_placeholder"] : messages["zip_placeholder"])}
                                    onChange={this.handleFormChange}
                                />
                            </div>
                        </div>
                        <div className={'row px-3 mb-3'}>
                            <div className={'col-12'}>
                                <label htmlFor="email" className={'mb-0 text-secondary'}>
                                    <small>
                                        <FormattedMessage
                                            id="proposal.checkout.phone_number_label"
                                            defaultMessage="Phone number"
                                        />
                                    </small>
                                </label>
                                <PhoneNumberInput
                                    type="tel"
                                    className="form-control "
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    phoneNumber={this.state.phoneNumber}
                                    checkValidForm={this.state.checkValidForm}
                                    placeholder={this.props.intl.formatMessage(messages["phone_number_placeholder"])}
                                    onChange={this.handlePhoneChange}
                                    message={<FormattedMessage
                                        id="customer.modal.add_form.contactPhoneNumber_field_error"
                                        defaultMessage="Please ensure the phone number is filled out properly"
                                    />}
                                />
                            </div>
                        </div>
                        {!this.state.section.attributes.content.hideShipping ? <div className={'row px-3 mb-2'}>
                            <div className={'col-12 pt-2 bg-light pb-3'}>
                                <Checkbox
                                    style={{ cursor: 'pointer' }}
                                    className={'mr-2'}
                                    color={this.state.variables.global.primaryColor}
                                    size={3}
                                    borderthickness={3}
                                    id={'sameBillingAddress'}
                                    checked={this.state.sameBillingAddress}
                                    onChange={isChecked => {
                                        this.setState({
                                            proceedingToPayment: false,
                                            sameBillingAddress: isChecked,
                                            billingPostalCode: ""
                                        }, this.saveInCookies)
                                    }} />
                                <label htmlFor="sameBillingAddress" className={'mb-0 text-secondary'}>
                                    <FormattedMessage
                                        id="proposal.checkout.use_same_billing_contact_label"
                                        defaultMessage="Use the contact info for billing"
                                    />
                                </label>
                            </div>
                        </div> : null}
                        {!this.state.sameBillingAddress && !this.state.section.attributes.content.hideShipping ? <div className={'row mb-3'}>
                            <div className={'col-12'}>
                                <div className={'row px-3'}>
                                    <div className={'col-12 bg-light pb-2'}>
                                        <label htmlFor="billingEmail" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.email_label"
                                                    defaultMessage="Email"
                                                />
                                            </small>
                                        </label>
                                        <EmailInput
                                            required={true}
                                            type="billingEmail"
                                            className="form-control "
                                            id="billingEmail"
                                            name="billingEmail"
                                            email={this.state.billingEmail}
                                            placeholder={this.props.intl.formatMessage(messages["email_placeholder"])}
                                            handleFormChange={this.handleFormChange}
                                        />
                                    </div>
                                </div>
                                <div className={'row px-3'}>
                                    <div className={'col-12 col-lg-6 bg-light pb-2'}>
                                        <label htmlFor="billingFirstName" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.first_name_label"
                                                    defaultMessage="First Name"
                                                />
                                            </small>
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            className="form-control "
                                            id="billingFirstName"
                                            name="billingFirstName"
                                            value={this.state.billingFirstName}
                                            placeholder={this.props.intl.formatMessage(messages["first_name_placeholder"])}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                    <div className={'col-12 col-lg-6 bg-light pb-2'}>
                                        <label htmlFor="billingLastName" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.last_name_label"
                                                    defaultMessage="Last Name"
                                                />
                                            </small>
                                        </label>
                                        <input
                                            required
                                            type="text"
                                            className="form-control "
                                            id="billingLastName"
                                            name="billingLastName"
                                            value={this.state.billingLastName}
                                            placeholder={this.props.intl.formatMessage(messages["last_name_placeholder"])}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                </div>
                                <div className={'row px-3'}>
                                    <div className={'col-12 col-lg-8 bg-light pb-2'}>
                                        <label htmlFor="billingAddress" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.address_label"
                                                    defaultMessage="Address"
                                                />
                                            </small>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control "
                                            id="billingAddress"
                                            name="billingAddress"
                                            value={this.state.billingAddress}
                                            placeholder={this.props.intl.formatMessage(messages["address_placeholder"])}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                    <div className={'col-12 col-lg-4 bg-light pb-2'}>
                                        <label htmlFor="billingCity" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.city_label"
                                                    defaultMessage="City"
                                                />
                                            </small>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control "
                                            id="billingCity"
                                            name="billingCity"
                                            value={this.state.billingCity}
                                            placeholder={this.props.intl.formatMessage(messages["city_placeholder"])}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                </div>
                                <div className={'row px-3'}>
                                    <div className={'col-12 col-lg-4 bg-light pb-2'}>
                                        <label htmlFor="billingCountry" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.country_label"
                                                    defaultMessage="Country"
                                                />
                                            </small>
                                        </label>
                                        <CountrySelect
                                            name="billingCountry"
                                            countryCode={this.state.billingCountry}
                                            onChange={(_, code) => {
                                                this.setState({ billingCountry: code }, this.saveInCookies)
                                            }}
                                        />
                                    </div>
                                    <div className={'col-12 col-lg-4 bg-light pb-2'}>
                                        <label htmlFor="billingState" className={'mb-0 text-secondary'}>
                                            <small>
                                                {this.state.billingCountry === 'CA' ? <FormattedMessage
                                                    id="proposal.checkout.province_label"
                                                    defaultMessage="Province"
                                                /> : <FormattedMessage
                                                    id="proposal.checkout.state_label"
                                                    defaultMessage="State"
                                                />}
                                            </small>
                                        </label>
                                        <StateSelect
                                            name="billingState"
                                            value={this.state.billingState}
                                            countryCode={this.state.billingCountry}
                                            placeholder={this.props.intl.formatMessage(this.state.billingCountry === 'CA' ? messages["province_placeholder"] : messages["zip_placeholder"])}
                                            onChange={(_, code) => {
                                                this.setState({ billingState: code }, this.saveInCookies)
                                            }}
                                        />
                                    </div>
                                    <div className={'col-12 col-lg-4 bg-light pb-2'}>
                                        <label htmlFor="billingPostalCode" className={'mb-0 text-secondary'}>
                                            <small>
                                                {this.state.billingCountry === 'CA' ? <FormattedMessage
                                                    id="proposal.checkout.postal_code_label"
                                                    defaultMessage="Postal code"
                                                /> : <FormattedMessage
                                                    id="proposal.checkout.zip_label"
                                                    defaultMessage="Zip"
                                                />}
                                            </small>
                                        </label>
                                        <PostalCodeInput
                                            type="text"
                                            className="form-control "
                                            id="billingPostalCode"
                                            name="billingPostalCode"
                                            postalCode={this.state.billingPostalCode}
                                            countryCode={this.state.country}
                                            placeholder={this.props.intl.formatMessage(this.state.billingCountry === 'CA' ? messages["postal_code_placeholder"] : messages["zip_placeholder"])}
                                            onChange={this.handleFormChange}
                                        />
                                    </div>
                                </div>
                                <div className={'row px-3 mb-3'}>
                                    <div className={'col-12 bg-light pb-3'}>
                                        <label htmlFor="billingPhoneNumber" className={'mb-0 text-secondary'}>
                                            <small>
                                                <FormattedMessage
                                                    id="proposal.checkout.phone_number_label"
                                                    defaultMessage="Phone number"
                                                />
                                            </small>
                                        </label>
                                        <PhoneNumberInput
                                            type="tel"
                                            className="form-control "
                                            id="billingPhoneNumber"
                                            checkValidForm={this.state.checkValidForm}
                                            name="billingPhoneNumber"
                                            phoneNumber={this.state.billingPhoneNumber}
                                            placeholder={this.props.intl.formatMessage(messages["phone_number_placeholder"])}
                                            onChange={this.handleBillingPhoneChange}
                                            message={<FormattedMessage
                                                id="customer.modal.add_form.contactBillingPhoneNumber_field_error"
                                                defaultMessage="Please ensure the billing phone number is filled out properly"
                                            />}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> : null}
                        <div className={'row px-3 mb-2'}>
                            {this.state.formError && <div className="alert alert-danger alert-dismissible fade show w-100" role="alert">
                                <button type="button" className="close" data-dismiss="alert" aria-label="Close" onClick={() => {
                                    this.setState({ formError: '' })
                                }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <FormattedMessage
                                    id="customer.modal.add_form.error_section_checkout_message"
                                    defaultMessage="Error! {errorMessage}"
                                    values={{ errorMessage: this.state.formError }}
                                />
                            </div>}
                            <div className={'col-12 justify-content-end d-flex'}>
                                <ActionButton className="btn btn-primary py-2 approve-btn" type={'submit'} style={{
                                    outlineColor: this.state.variables.global.buttonColor,
                                    backgroundColor: this.state.variables.global.buttonColor,
                                    borderColor: this.state.variables.global.buttonColor,
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                }} onClick={this.continueToPayment}
                                    isLoading={this.state.proceedingToPayment}>
                                    {hidePayment ? <FormattedMessage
                                        id="proposal.checkout.continue_label"
                                        defaultMessage="Continue"
                                    /> : <FormattedMessage
                                        id="proposal.checkout.continue_to_payment_label"
                                        defaultMessage="Continue to payment"
                                    />}
                                </ActionButton>
                            </div>
                        </div>
                    </form>
                </div> : <div className={'col-12 border-bottom py-2'}>
                    <div className={'row mb-2'}>
                        <div className={'col-12 d-flex align-items-center'}>
                            <div className={'h3 mb-0 mr-2 d-flex align-items-center'}>
                                <span className="badge badge-pill badge-primary"
                                    style={{
                                        outlineColor: this.state.variables.global.primaryColor,
                                        backgroundColor: this.state.variables.global.primaryColor,
                                        borderColor: this.state.variables.global.primaryColor,
                                    }}
                                >1</span>
                            </div>
                            <div className={'flex-fill'}>
                                <h4 className={'mb-0'}>
                                    <FormattedMessage
                                        id="proposal.checkout.contact_information"
                                        defaultMessage="Contact information"
                                    />
                                </h4>
                            </div>
                        </div>
                    </div>
                    <div className={'row px-3 mb-3'}>
                        {!this.state.section.attributes.content.hideShipping ? <div className={'col-12 col-lg-3'}>
                            <label className={'mb-0 text-secondary'}>
                                <small>
                                    <FormattedMessage
                                        id="proposal.checkout.shipping_contact_label"
                                        defaultMessage="Shipping contact"
                                    />
                                </small>
                            </label>
                            <p className={'mb-0 text-truncate'}>{shipToName}</p>
                            <p className={'mb-0 text-truncate'}>{shipToEmail}</p>
                            <p className={'mb-0'}>{shipToPhoneNumber}</p>
                        </div> : null}
                        {!this.state.section.attributes.content.hideShipping ? <div className={'col-12 col-lg-3'}>
                            <label className={'mb-0 text-secondary'}>
                                <small>
                                    <FormattedMessage
                                        id="proposal.checkout.shipping_address_label"
                                        defaultMessage="Shipping address"
                                    />
                                </small>
                            </label>
                            <p className={'mb-0'}>
                                <AddressComponentSSR localeWithoutRegionCode={AppContext.getLocale().getLanguageWithoutRegionCode()} value={shipToAddress} />

                            </p>
                        </div> : null}
                        <div className={`col-12 ${colContactInfoSize}`}>
                            <label className={'mb-0 text-secondary'}>
                                <small>
                                    <FormattedMessage
                                        id="proposal.checkout.billing_contact_label"
                                        defaultMessage="Billing contact"
                                    />
                                </small>
                            </label>
                            <p className={'mb-0 text-truncate'}>{billingName}</p>
                            <p className={'mb-0 text-truncate'}>{billingEmail}</p>
                            <p className={'mb-0'}>{billingPhoneNumber}</p>
                        </div>
                        <div className={`col-12 ${colContactInfoSize}`}>
                            <label className={'mb-0 text-secondary'}>
                                <small>
                                    <FormattedMessage
                                        id="proposal.checkout.billing_address_label"
                                        defaultMessage="Billing address"
                                    />
                                </small>
                            </label>
                            <p className={'mb-0'}>
                                <AddressComponentSSR localeWithoutRegionCode={AppContext.getLocale().getLanguageWithoutRegionCode()} value={billingAddress} />
                            </p>
                        </div>
                        <div className={'col-12 mt-2'}>
                            <button className="btn btn-sm btn-primary approve-btn" style={{
                                outlineColor: this.state.variables.global.buttonColor,
                                backgroundColor: this.state.variables.global.buttonColor,
                                borderColor: this.state.variables.global.buttonColor,
                            }} onClick={this.backToContact}>
                                <FormattedMessage
                                    id="proposal.checkout.change_contact_label"
                                    defaultMessage="Change"
                                />
                            </button>
                        </div>
                    </div>
                </div>}
                {!showPaymentStep ? <div className={'col-12 py-2'}>
                    <div className={'row mb-2 pt-2'}>
                        <div className={'col-12 d-flex align-items-center'}>
                            <div className={'h3 mb-0 mr-2 d-flex align-items-center'}>
                                <span className="badge badge-pill badge-secondary">2</span>
                            </div>
                            <div className={'flex-fill'}>
                                <h4 className={'mb-0 text-secondary'}>
                                    {hidePayment ? <FormattedMessage
                                        id="proposal.checkout.confirmation"
                                        defaultMessage="Confirmation"
                                    /> : <FormattedMessage
                                        id="proposal.checkout.payment"
                                        defaultMessage="Payment"
                                    />}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div> : <div className={'col-12 py-2'}>
                    <div className={'row mb-3 pt-2'}>
                        <div className={'col-12 d-flex align-items-center'}>
                            <div className={'h3 mb-0 mr-2 d-flex align-items-center'}>
                                <span className="badge badge-pill badge-primary"
                                    style={{
                                        outlineColor: this.state.variables.global.primaryColor,
                                        backgroundColor: this.state.variables.global.primaryColor,
                                        borderColor: this.state.variables.global.primaryColor,
                                    }}
                                >2</span>
                            </div>
                            <div className={'flex-fill'}>
                                <h4 className={'mb-0'}>
                                    {hidePayment ? <FormattedMessage
                                        id="proposal.checkout.confirmation"
                                        defaultMessage="Confirmation"
                                    /> : <FormattedMessage
                                        id="proposal.checkout.payment"
                                        defaultMessage="Payment"
                                    />}
                                </h4>
                            </div>
                        </div>
                    </div>
                    {hidePayment ?
                        <div className={'row px-3 pt-2'}>
                            <div className={'col-12 text-center'}>
                                <ActionButton
                                    loadingTimeout={5000}
                                    className="btn btn-lg btn-primary px-4"
                                    style={{
                                        outlineColor: this.state.variables.global.buttonColor,
                                        backgroundColor: this.state.variables.global.buttonColor,
                                        borderColor: this.state.variables.global.buttonColor,
                                        fontWeight: 'bold',
                                    }}
                                    onClick={() => this.handleSubmit(false)}
                                    disabled={parseFloat(this.state.variables.quote.totalAmount) == 0 ||
                                        (this.getPaymentAmount() > 0 &&
                                            !this.state.variables.isIntegrationConfigurationEnabled &&
                                            !this.hasShopifyCheckout())}
                                >
                                    {this.state.section.attributes.content.submitButtonLabel ? this.state.section.attributes.content.submitButtonLabel : <FormattedMessage
                                        id="proposal.checkout.submit_btn"
                                        defaultMessage="Confirm"
                                    />}
                                </ActionButton>
                                {this.state.itemCustomAttributeError &&
                                    <div className="text-danger mb-2 mt-2">
                                        <small>
                                            <Icon value={"exclamation"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="proposal.custom_attribute.error_message"
                                                defaultMessage="Please fill all required product attributes to continue"
                                            />
                                        </small>
                                    </div>
                                }
                                {this.state.customFieldRequiredError &&
                                    <div className="text-danger mb-2 mt-2">
                                        <small>
                                            <Icon value={"exclamation"} className={"mr-1"} />
                                            <FormattedMessage
                                                id="proposal.custom_field_required.error_message"
                                                defaultMessage="Please fill all required custom form fields to continue"
                                            />
                                        </small>
                                    </div>
                                }
                            </div>
                        </div> :
                        <div className="col-lg-12 d-flex flex-row flex-wrap">
                            {this.getDueAmount()}
                            <PaymentTypeTabs
                                paymentMethods={this.state.paymentMethods}
                                acceptedCardBrands={this.state.acceptedCardBrands}
                                variables={this.state.variables}
                                loading={this.state.loading}
                                contactId={this.state.contactId}
                                section={this.state.section}
                                firstName={this.state.firstName}
                                creditCardError={this.state.creditCardError}
                                getPaymentAmount={this.getPaymentAmount}
                                handleSubmit={this.handleSubmit}
                                handleSubmitNewCard={this.handleSubmitNewCard}
                                handlePaymentIntentCompleted={this.handlePaymentIntentCompleted}
                                isGolfContact={this.state.validationError == 'error-golf-contact'}
                                buildMetaData={this.buildMetaData}
                                proposalHash={this.state.variables.hash}
                                paymentAccount={this.state.variables.paymentAccount}
                                isIntegrationConfigurationEnabled={this.state.variables.isIntegrationConfigurationEnabled}
                            />
                        </div>}
                </div>}
            </SectionWrapper>
        );
    }
}

export default injectIntl(CheckoutContentSection)


// WEBPACK FOOTER //
// ./src/template/sections/content/checkout/section.component.jsx